// Dictionary for common store / fireworks / product terms
const dictionary = {
  // Common Crackers & Fireworks
  "bijili": "பிஜிலி",
  "bijili's": "பிஜிலி",
  "laxshmi": "லக்ஷ்மி",
  "lakshmi": "லக்ஷ்மி",
  "laxmi": "லக்ஷ்மி",
  "lakshmy": "லக்ஷ்மி",
  "laxmy": "லக்ஷ்மி",
  "stripped": "வரி",
  "striped": "வரி",
  "super": "சூப்பர்",
  "deluxe": "டீலக்ஸ்",
  "deuxe": "டீலக்ஸ்",
  "dlx": "டீலக்ஸ்",
  "gold": "கோல்ட்",
  "golden": "கோல்டன்",
  "kalis": "காலிஸ்",
  "jallikattu": "ஜல்லிக்கட்டு",
  "paper": "பேப்பர்",
  "bomb": "பாம்",
  "bombs": "பாம்ஸ்",
  "flower": "பிளவர்",
  "pots": "பாட்ஸ்",
  "pot": "பாட்",
  "big": "பிக்",
  "small": "ஸ்மால்",
  "special": "ஸ்பெஷல்",
  "spl": "ஸ்பெஷல்",
  "kuruvi": "குருவி",
  "kururi": "குருவி",
  "bird": "பர்ட்",
  "birds": "பர்ட்ஸ்",
  "sound": "சவுண்ட்",
  "crackers": "கிராக்கர்ஸ்",
  "cracker": "கிராக்கர்",
  "sparklers": "ஸ்பார்க்லர்ஸ்",
  "sparkler": "ஸ்பார்க்லர்",
  "chakkar": "சக்கரம்",
  "chakkars": "சக்கரம்",
  "chakkara": "சக்கரம்",
  "atom": "ஆட்டம்",
  "rocket": "ராக்கெட்",
  "rockets": "ராக்கெட்ஸ்",
  "fountain": "பவுண்டன்",
  "fountains": "பவுண்டன்கள்",
  "garland": "சரம்",
  "garlands": "சரம்",
  "wala": "வாலா",
  "walaa": "வாலா",
  "shot": "ஷாட்",
  "shots": "ஷாட்ஸ்",
  "fancy": "பேன்சி",
  "sky": "ஸ்கை",
  "match": "மேட்ச்",
  "box": "பாக்ஸ்",
  "boxes": "பாக்ஸ்",
  "roll": "ரோல்",
  "cap": "கேப்",
  "caps": "கேப்ஸ்",
  "silver": "சில்வர்",
  "green": "கிரீன்",
  "red": "ரெட்",
  "blue": "ப்ளூ",
  "yellow": "யெல்லோ",
  "multi": "மல்டி",
  "color": "கலர்",
  "colour": "கலர்",
  "colors": "கலர்ஸ்",
  "giant": "ஜயன்ட்",
  "gaint": "ஜயன்ட்",
  "mega": "மெகா",
  "mini": "மினி",
  "star": "ஸ்டார்",
  "stars": "ஸ்டார்ஸ்",
  "twinkling": "டிவிங்க்ளிங்",
  "peacock": "மயில்",
  "serial": "சீரியல்",
  "wheel": "வீல்",
  "wheels": "வீல்ஸ்",
  "ground": "கிரவுண்ட்",
  "electric": "எலக்ட்ரிக்",
  "stone": "ஸ்டோன்",
  "snake": "ஸ்நேக்",
  "dora": "டோரா",
  "chota": "சோட்டா",
  "chotta": "சோட்டா",
  "bheem": "பீம்",
  "ben": "பென்",
  "cartoon": "கார்ட்டூன்",
  "gift": "கிஃப்ட்",
  "pack": "பேக்",
  "packet": "பாக்கெட்",
  "packets": "பாக்கெட்கள்",
  "pcs": "பீஸ்",
  "piece": "பீஸ்",
  "pieces": "பீஸ்கள்",
  "bag": "பேக்",
  "bags": "பேக்",
  "tin": "டின்",
  "pouch": "பவுச்",
  "gms": "கிராம்",
  "gm": "கிராம்",
  "gram": "கிராம்",
  "grams": "கிராம்",
  "kg": "கிலோ",
  "kgs": "கிலோ",
  "kilo": "கிலோ",
  "ply": "ப்ளை",
  "plain": "சாதா",
  "cm": "செ.மீ",
  "combo": "காம்போ",
  "gun": "துப்பாக்கி",
  "stick": "குச்சி",
  "glass": "கண்ணாடி",
  "speed": "ஸ்பீட்",
  "magic": "மேஜிக்",
  "trick": "ட்ரிக்",
  "pop": "பாப்",
  "heavy": "ஹெவி",
  "quality": "குவாலிட்டி",
  "naatu": "நாட்டு",
  "nattu": "நாட்டு",
  "vedi": "வெடி",
  "peedi": "பீடி",
  "spinner": "ஸ்பின்னர்",
  "spinning": "ஸ்பின்னர்",
  "whistle": "விசில்",
  "whistling": "விஸ்லிங்",
  "cone": "கோன்",
  "shower": "சவர்",
  "koti": "கோட்டி",
  "kotti": "கோட்டி",
  "adiyaal": "அடியாள்",
  "missile": "மிஸைல்",
  "eagle": "ஈகிள்",
  "metal": "மெட்டல்",
  "metalic": "மெட்டாலிக்",
  "metallic": "மெட்டாலிக்",
  "premium": "பிரீமியம்",
  "primium": "பிரீமியம்",
  "ultra": "அல்ட்ரா",
  "standard": "ஸ்டாண்டர்ட்",
  "normal": "சாதா",
  "vari": "வரி",
  "white": "வெள்ளை",
  "black": "கருப்பு",
  "smoke": "ஸ்மோக்",
  "bullet": "புல்லட்",
  "hydro": "ஹைட்ரோ",
  "ladi": "லடி",
  "bambaram": "பம்பரம்",
  "bumbaram": "பம்பரம்",
  "items": "பொருட்கள்",
  "item": "பொருட்கள்",
  "vip": "விஐபி",
  "digital": "டிஜிட்டல்",
  "batman": "பேட்மேன்",
  "jurassic": "ஜுராசிக்",
  "tracer": "டிரேசர்",
  "baby": "பேபி",
  "musical": "மியூசிகல்",
  "pc": "பீஸ்",
  "monster": "மான்ஸ்டர்",
  "feathers": "பெதர்ஸ்",
  "magical": "மேஜிக்கல்",
  "bada": "படா",
  "side": "சைடு",
  "pink": "பிங்க்",
  "max": "மேக்ஸ்",
  "beer": "பீர்",
  "popcorn": "பாப்கார்ன்",
  "corn": "கார்ன்",
  "double": "டபுள்",
  "ducker": "டக்கர்",
  "triple": "ட்ரிபிள்",
  "monkey": "மங்கி",
  "goli": "கோலி",
  "soda": "சோடா",
  "water": "வாட்டர்",
  "queen": "குயின்",
  "hand": "ஹேண்ட்",
  "safety": "சேப்டி",
  "pistol": "பிஸ்டல்",
  "pistal": "பிஸ்டல்",
  "selfi": "செல்பி",
  "selfie": "செல்பி",
  "angry": "ஆங்கிரி",
  "pogo": "போகோ",
  "animal": "அனிமல்",
  "dragon": "டிராகன்",
  "ball": "பால்",
  "balls": "பால்ஸ்",
  "holi": "ஹோலி",
  "fruits": "ப்ரூட்ஸ்",
  "lolly": "லாலி",
  "rainbow": "ரெயின்போ",
  "smock": "ஸ்மோக்",
  "butterfly": "பட்டர்பிளை",
  "pipe": "பைப்",
  "single": "சிங்கிள்",
  "varites": "வகைகள்",
  "varieties": "வகைகள்",
  "comet": "காமெட்",
  "dance": "டான்ஸ்",
  "crackling": "கிராக்க்ளிங்",
  "mud": "மண்",
  "changing": "சேஞ்சிங்",
  "ring": "ரிங்",
  "missel": "மிஸைல்",
  "hong": "ஹாங்",
  "kong": "காங்",
  "london": "லண்டன்",
  "new": "நியூ",
  "york": "யார்க்",
  "singapore": "சிங்கப்பூர்",
  "dubai": "துபாய்",
  "paris": "பாரிஸ்"
};

// Multi-word phrases (checked first)
const multiWordPhrases = [
  { en: "paper bomb", ta: "பேப்பர் பாம்" },
  { en: "paper bombs", ta: "பேப்பர் பாம்ஸ்" },
  { en: "flower pot", ta: "பூச்சட்டி" },
  { en: "flower pots", ta: "பூச்சட்டிகள்" },
  { en: "ground chakkar", ta: "கிரவுண்ட் சக்கரம்" },
  { en: "ground chakkars", ta: "கிரவுண்ட் சக்கரம்" },
  { en: "gift box", ta: "கிப்ட் பாக்ஸ்" },
  { en: "super deluxe", ta: "சூப்பர் டீலக்ஸ்" },
  { en: "gold deluxe", ta: "கோல்ட் டீலக்ஸ்" },
  { en: "red bijili", ta: "சிகப்பு பிஜிலி" },
  { en: "vari bijili", ta: "வரி பிஜிலி" },
  { en: "gold bijili", ta: "கோல்ட் பிஜிலி" },
  { en: "naatu vedi", ta: "நாட்டு வெடி" },
  { en: "peedi vedi", ta: "பீடி வெடி" },
  { en: "match stick", ta: "தீக்குச்சி" },
  { en: "magic trick", ta: "மேஜிக் ட்ரிக்" },
  { en: "pop pop", ta: "பாப் பாப்" },
  { en: "atom bomb", ta: "ஆட்டம் பாம்" },
  { en: "loose crackers", ta: "உதிரி வெடிகள்" },
  { en: "garland crackers", ta: "சர வெடிகள்" },
  { en: "new york", ta: "நியூயார்க்" },
  { en: "hong kong", ta: "ஹாங்காங்" },
  { en: "kit kat", ta: "கிட் கட்" },
  { en: "pop corn", ta: "பாப்கார்ன்" },
  { en: "bat ball", ta: "பேட் பால்" }
];

// Consonants and Vowels mapping for natural syllable transliteration
const consonants = [
  { en: "sh", ta: "ஷ்", base: "ஷ" },
  { en: "ch", ta: "ச்", base: "ச" },
  { en: "th", ta: "த்", base: "த" },
  { en: "dh", ta: "த்", base: "த" },
  { en: "ph", ta: "ஃப்", base: "ப" },
  { en: "kh", ta: "க்", base: "க" },
  { en: "gh", ta: "க்", base: "க" },
  { en: "zh", ta: "ழ்", base: "ழ" },
  { en: "ng", ta: "ங்", base: "ங" },
  { en: "nj", ta: "ஞ்", base: "ஞ" },
  { en: "k", ta: "க்", base: "க" },
  { en: "g", ta: "க்", base: "க" },
  { en: "c", ta: "க்", base: "க" },
  { en: "s", ta: "ஸ்", base: "ச" },
  { en: "j", ta: "ஜ்", base: "ஜ" },
  { en: "t", ta: "ட்", base: "ட" },
  { en: "d", ta: "ட்", base: "ட" },
  { en: "n", ta: "ன்", base: "ன" },
  { en: "p", ta: "ப்", base: "ப" },
  { en: "b", ta: "ப்", base: "ப" },
  { en: "m", ta: "ம்", base: "ம" },
  { en: "y", ta: "ய்", base: "ய" },
  { en: "r", ta: "ர்", base: "ர" },
  { en: "l", ta: "ல்", base: "ல" },
  { en: "v", ta: "வ்", base: "வ" },
  { en: "w", ta: "வ்", base: "வ" },
  { en: "h", ta: "ஹ்", base: "ஹ" },
  { en: "f", ta: "ஃப்", base: "ப" },
  { en: "z", ta: "ஜ்", base: "ஜ" },
  { en: "x", ta: "க்ஸ்", base: "க்ஸ்" }
];

const vowels = [
  { en: "aa", sign: "ா", init: "ஆ" },
  { en: "ee", sign: "ீ", init: "ஈ" },
  { en: "ii", sign: "ீ", init: "ஈ" },
  { en: "oo", sign: "ூ", init: "ஊ" },
  { en: "uu", sign: "ூ", init: "ஊ" },
  { en: "ai", sign: "ை", init: "ஐ" },
  { en: "au", sign: "ௌ", init: "ஔ" },
  { en: "a", sign: "", init: "அ" },
  { en: "e", sign: "ெ", init: "எ" },
  { en: "i", sign: "ி", init: "இ" },
  { en: "o", sign: "ொ", init: "ஒ" },
  { en: "u", sign: "ு", init: "உ" }
];

function phoneticTransliterate(word) {
  let rem = word.toLowerCase();
  let result = "";

  while (rem.length > 0) {
    // 1. Check if starts with consonant
    let foundC = null;
    for (let i = 0; i < consonants.length; i++) {
      if (rem.startsWith(consonants[i].en)) {
        foundC = consonants[i];
        break;
      }
    }

    if (foundC) {
      rem = rem.slice(foundC.en.length);
      // Check if followed by vowel
      let foundV = null;
      for (let i = 0; i < vowels.length; i++) {
        if (rem.startsWith(vowels[i].en)) {
          foundV = vowels[i];
          break;
        }
      }

      if (foundV) {
        rem = rem.slice(foundV.en.length);
        result += foundC.base + foundV.sign;
      } else {
        result += foundC.ta;
      }
    } else {
      // Starts with vowel
      let foundV = null;
      for (let i = 0; i < vowels.length; i++) {
        if (rem.startsWith(vowels[i].en)) {
          foundV = vowels[i];
          break;
        }
      }

      if (foundV) {
        rem = rem.slice(foundV.en.length);
        result += foundV.init;
      } else {
        result += rem[0];
        rem = rem.slice(1);
      }
    }
  }
  return result;
}

function translateWord(w) {
  if (!w) return "";
  // If already contains Tamil, return as is
  if (/[\u0B80-\u0BFF]/.test(w)) return w;

  // Separate leading punctuation (e.g. quotes, brackets) and trailing punctuation
  const match = w.match(/^([^a-zA-Z0-9]*)(.*?)([^a-zA-Z0-9]*)$/);
  if (!match) return w;
  const [, pre, core, post] = match;

  if (!core) return w;

  // Keep numbers, fractions, pure symbols, and single letters (like 'D', 'A', 'J')
  if (/^[\d/".\-+]+$/.test(core) || (core.length === 1 && /^[a-zA-Z]$/.test(core))) {
    return w;
  }

  const lower = core.toLowerCase();
  if (dictionary[lower]) {
    return pre + dictionary[lower] + post;
  }

  // Fallback to syllable-based transliteration
  return pre + phoneticTransliterate(core) + post;
}

export function translateToTamil(text) {
  if (text == null) return "";
  let str = String(text).trim();
  if (!str) return "";
  if (/[\u0B80-\u0BFF]/.test(str)) return str;

  // 1. Check multi-word phrases (case insensitive)
  for (const phrase of multiWordPhrases) {
    const reg = new RegExp(`\\b${phrase.en}\\b`, 'gi');
    str = str.replace(reg, phrase.ta);
  }

  // 2. Tokenize by whitespace
  const words = str.split(/(\s+)/);
  return words.map(w => {
    if (/^\s+$/.test(w)) return w;
    return translateWord(w);
  }).join('');
}

export default translateToTamil;
